<template>
  <div class="district-picker-banner">
    <a-icon class="district-picker-banner-icon" icon="16:info" />
    <a-text as="p" class="district-picker-banner-text">
      {{ $t('districtPicker.bannerText') }}
    </a-text>
  </div>
</template>

<style scoped lang="scss">
.district-picker-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 460px;
  padding: 8px 10px;
  margin: 32px 0;

  background: #f3fafc;
  border: 1px solid #c7e7f5;
  border-radius: 8px;
  box-shadow: 0px 2px 2px rgba(45, 45, 45, 0.1), 0px 0px 2px rgba(45, 45, 45, 0.12);

  &-icon {
    color: #04668f;
    flex-shrink: 0;
  }

  &-text {
    color: #04668f;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.4px;
    text-align: left;
  }
}
</style>

